<template>
  <div id="loading-cover" class="workspace__loading" style="z-index: 42;">
    <div class="workspace--loading-zone">
      <div class="workspace--loading-zone--inner">
        <!-- 캐릭터 -->
        <div class="workspace--loading-zone__char" :class="{ peng: !$route.params.id.indexOf('ESOF02'), jb: !$route.params.id.indexOf('ESOF03') }"></div>

        <!-- 로딩바 -->
        <div class="workspace--loading-zone__gauge__wrap">
          <div class="workspace--loading-zone__gauge">
            <div class="workspace--loading-zone__gauge--real" v-bind:style="{width: loadingRate + '%'}"></div>
          </div>
        </div>

        <!-- 텍스트 -->
        <div class="workspace--loading-zone__txt">
          학습에 필요한 데이터를 조회중입니다.<br/>
          잠시만 기다려 주세요.
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'loadingTemplate',
    data() {
      return {
        loadingRate: 0,
      }
    },
    computed: {},
    methods: {
      /**
       *  @DESC   미션 데이터 수집 실패 처리
       *  @INPUT
       *  @OUTPUT
       */
      failTask() {
        console.log('failTask')
      }

    },
    mounted() {
      setTimeout(() => {
        this.loadingRate = 100;
      })
    }
  }
</script>

<style lang="less" scoped>

</style>



// WEBPACK FOOTER //
// src/components/stage/StagePartialLoading.vue